import {css} from '@emotion/css';

import {colours} from '../../../../styles/js/variables/colours';
import {spacing} from '../../../../styles/js/variables/spacing';

const styles = {
  container: css`
    label: grayline__container;
    margin: 0;
    padding: 0;
  `,
  line: css`
    label: grayline__line;
    display: block;
    height: 0.1rem;
    margin: ${spacing.XXS} 0;
    padding: 0;
    border: 0;
    border-top: 1px solid ${colours.border.LIGHT_GRAY};
  `,
};
export default styles;
